import Rx from 'rxjs';
import { push } from 'react-router-redux';
import { combineEpics } from 'redux-observable';

import * as constAction from 'root/actionConstants';
import * as gruposActions from 'modules/grupos/action';
import * as generalActions from 'modules/general/action';
import * as errorActions from 'modules/error/action';
import { request } from 'core/generalFunctions';

const { ajax } = Rx.Observable;

export const getEpic = (action$, store) =>
  action$.ofType(constAction.GRUPOS_GET).switchMap(action =>
    ajax(request(action))
      .map(({ response }) => gruposActions.setState({ lista: response }))
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const setEpic = (action$, store) =>
  action$
    .ofType(constAction.GRUPOS_SET)
    .throttleTime(1000)
    .switchMap(action =>
      ajax(request(action))
        .mergeMap(({ response }) => [
          push('/dashboard/grupos/add/' + (action.payload.grupoId || response.id)),
          generalActions.snackbar_show('Grupo guardado'),
          gruposActions.getById(action.payload.grupoId || response.id),
        ])
        .catch(err => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const deleteEpic = (action$, store) =>
  action$.ofType(constAction.GRUPOS_DELETE).switchMap(action =>
    ajax(request(action))
      .mergeMap(() => [gruposActions.get(), generalActions.snackbar_show('Grupo eliminado')])
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const getByIdEpic = (action$, store) =>
  action$.ofType(constAction.GRUPOS_GET_BY_ID).switchMap(action =>
    ajax(request(action))
      .map(({ response }) => {
        response._usuarios = response._usuarios.map(user => {
          user.seleccionado = true;
          return user;
        });
        return response;
      })
      .map(grupo => gruposActions.setState({ grupo }))
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const modificarUsuariosGrupoEpic = (action$, store) =>
  action$.ofType(constAction.GRUPOS_MODIFICAR_USUARIOS).switchMap(action =>
    ajax(request(action))
      .mergeMap(() => {
        const { usuarioId } = action.payload;
        const usuarioMap = (store.getState().getIn(['abonados', 'lista', 0]) || []).find(user => user.get('id') === usuarioId);

        return [
          gruposActions.modificarUsuariosGrupo(usuarioMap),
          generalActions.snackbar_show('Usuario/s del grupo modificados')
        ];
      })
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const deleteUsuarioGrupoEpic = (action$, store) =>
  action$.ofType(constAction.GRUPOS_DELETE_USUARIO)
    .switchMap(action =>
      ajax(request(action))
        .mergeMap(() => {
          const { usuariosId } = action.payload;
          const usuarioMap =
            (store.getState().getIn(['grupos', 'grupo', '_usuarios']))
              .find(user => user.get('id') === usuariosId);

          return [
            gruposActions.modificarUsuariosGrupo(usuarioMap),
            generalActions.snackbar_show('Usuario eliminado del grupo')
          ];
        })
        .catch(err => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export default combineEpics(getEpic, setEpic, deleteEpic, getByIdEpic, modificarUsuariosGrupoEpic, deleteUsuarioGrupoEpic);



// WEBPACK FOOTER //
// src/modules/grupos/epics.js